import React from "react";

const Footer = () => {
  return <footer className="w-full text-center text-text2 text-paragraph3 lg:text-paragraph1 lg:mt-2 lg:my-0 my-6 ">©2023 Hawa Apps by Daffa Fawwaz Aditya</footer>;
};

export default Footer;
